export const mutationResult = `
  success
  message
  data
`;

export const preReservedParticipantSchema = `
  reservation_id
  date
  workspace
  expired_at
  customer_uuid
  horanet_id
  firstname
  lastname
  id
  sessionPre_reserved_participantsId
`;

export const sessionSchema = `
  id
  uuid
  name
  start_time
  end_time
  wtype
  max_participant
  min_participant
  cancelled
  horanet_id
  type
  horanet_product_code
  horanet_product_reference
  recurring
  allDay
  observation
  recurring_uuid
  start_recurring_date
  end_recurring_date
  workspace
  instructors
  horses
  place
  participants
  destination
  treatment_type
  mare
  discipline {
    uuid
    wtitle
  }
  standard
  replica {
    replica_type
    replica_option
    replica_interval
    replica_weeks
    excludeHolidays
    excludeVacations
  }
  product
  activity
  products
  product_activity{
    product
    activity
  }
  session_age_min
  session_age_max
  session_mount_type
  session_closed
  activity_code
  codeSiteComptage
  lastSessionTimeStamp
  kavalog_id
  horse_size_category
  groupeHorseEffort
  metadata
  periods {
    periodID
    start
    end
  }
  participantsAmount
  pre_reserved_participants {
    items {
      ${preReservedParticipantSchema}
    }
}`;
